import { API_V2_BASE_URL, API_JWT_BASE_URL } from '../http'

export const GET_BOARDTYPE_API = `${API_V2_BASE_URL}/boardtype`

export const GET_DEVICE_FORMATION_API = `${API_JWT_BASE_URL}/deviceformationtype`

export const DEVICE_FORMATION_QUERY_KEYS = {
  GET_DEVICE_FORMATION_TYPES: 'getDeviceFormationTypes',
  GET_DEVICE_FORMATION_TYPE: 'getDeviceFormationType',
  GET_DEVICE_FORMATION: 'getDeviceFormation',
  GET_DEVICE_FORMATIONINFO: 'getDeviceFormationInfo'
}
